import * as React from 'react';
import * as styles from './styles.css';

import { ILegend } from '../../../types/redux';
import { BulletListItem } from '../../BulletListItem';

export interface ILegendProps {
  legend: ILegend[];
}

export function Legend({ legend }: ILegendProps) {
  return (
    <div className={styles['legend']}>
      {legend.map((legend, index) => {
        return (
          <BulletListItem key={`${legend.color}_${index}`} inline bulletColor={legend.color}>
            {legend.label}
          </BulletListItem>
        );
      })}
    </div>
  );
}
